export default __webpack_public_path__ + "static/media/news52.cacea9e1.jpg";